export default __webpack_public_path__ + "static/media/news-six1.1e79b073.jpg";